<template>
    <main id="content" class="content-default result-content relative-section">
        <div class="container">
            <div class="relative-section">
                <FilterSidebar />
                <div class="primary-main">
                    <div class="relative-section">
                        <div class="brecrump font-bai">
                            <router-link to="/">{{
                                $t("app.Home")
                            }}</router-link
                            >/
                            <b>{{ $t("app.Recherche") }}</b>
                        </div>
                        <h2
                            class="relative-section text-center section-title font-balo"
                        >
                            <span class="font-bold">{{
                                $t("app.résultats")
                            }}</span>
                            <b class="font-bai" v-if="rooms.length === 0">
                                <small>
                                    {{
                                        $t(
                                            "app.correspondent à votre recherche"
                                        )
                                    }}
                                </small>
                            </b>
                        </h2>
                        <div
                            class="nodata text-center"
                            v-if="rooms.length === 0"
                        >
                            <img src="../assets/images/notfound.png" alt />
                            <br />
                            <a
                                href
                                @click.prevent="onGotoSearch()"
                                class="btn font-balo"
                                >{{ $t("app.Voir nos offres disponibles") }}</a
                            >
                        </div>
                        <div class="layout-view">
                            <a
                                href="#grid-view"
                                class="grid-view"
                                v-bind:class="{ active: viewing === 'grid' }"
                                @click.prevent="changeViewing('grid')"
                            ></a>
                            <a
                                href="#list-view"
                                v-bind:class="{ active: viewing === 'list' }"
                                class="list-view"
                                @click.prevent="changeViewing('list')"
                            ></a>
                        </div>
                        <ul
                            id="grid-view"
                            class="product-view product-list product-list-search slider-call slider-default row"
                            v-bind:class="{ active: viewing === 'grid' }"
                        >
                            <li
                                class="col-sm-4"
                                v-for="(room, index) in rooms"
                                :key="index"
                            >
                                <RoomGridItem
                                    :room="room"
                                    :filter="filter"
                                    v-if="!room.is_place"
                                />
                                <RoomPlaceGridItem
                                    :room="room"
                                    :filter="filter"
                                    v-if="room.is_place"
                                />
                            </li>
                        </ul>
                        <ul
                            id="list-view"
                            class="product-view product-list product-list-search"
                            v-bind:class="{ active: viewing === 'list' }"
                        >
                            <li v-for="(room, index) in rooms" :key="index">
                                <RoomListItem
                                    :room="room"
                                    :filter="filter"
                                    v-if="!room.is_place"
                                />
                                <RoomPlaceListItem
                                    :room="room"
                                    :filter="filter"
                                    v-if="room.is_place"
                                />
                            </li>
                        </ul>
                        <BackToTop />
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import FilterSidebar from "@/components/FilterSidebar";
import RoomGridItem from "@/components/RoomGridItem";
import RoomListItem from "@/components/RoomListItem";
import RoomPlaceListItem from "@/components/RoomPlaceListItem";
import RoomPlaceGridItem from "@/components/RoomPlaceGridItem";
import BackToTop from "@/components/BackToTop";
import { get, map, includes, filter, first } from "lodash";
import { formatBookDate } from "@/helper/calculateDays";
import { ADULT_COUNT_DEFAULT } from "@/api/config";
import { setDescriptionPage } from "@/helper/helper";
import moment from "moment";
export default {
    name: "ResultPage",
    data() {
        return {
            viewing: "list",
            descriptionPage: ""
        };
    },
    components: {
        RoomGridItem,
        RoomListItem,
        RoomPlaceListItem,
        RoomPlaceGridItem,
        FilterSidebar,
        BackToTop
    },
    mounted() {
        this.getCategories();
        this.getCampingClubs();
        this.getTypes();
        this.getInitReferences();
        if (this.$isMobile()) {
            this.viewing = "grid";
        }
        setDescriptionPage(get(this.general, "search_page_metades"));
    },
    computed: {
        ...mapMutations("hotels", ["setFilter"]),
        ...mapState({
            general: state => get(state, "app.general", {}),
            campingClubs: state => get(state, "campingClubs.list", []),
            filter: state => get(state, "hotels.filter", {}),
            // roomCategoriesMews: state => get(state, 'hotels.hotels.RoomCategories'),
            rooms: state => {
                const roomCategoryAvailabilities = get(
                    state,
                    "hotels.roomCategoryAvailabilities"
                );
                const filterData = get(state, "hotels.filter", {});
                let rawPlaces = get(
                    state,
                    "hotels.references.raw_place",
                    []
                ).map(place => ({
                    ...place,
                    is_place: true
                }));
                if (filterData.type) {
                    rawPlaces = filter(rawPlaces, rawPlace =>
                        includes(rawPlace.types || [], filterData.type)
                    );
                }
                return [...roomCategoryAvailabilities, ...rawPlaces];
            }
        })
    },
    methods: {
        ...mapActions("hotels", ["getAvailability", "getReferences"]),
        ...mapActions("categories", ["getCategories"]),
        ...mapActions("types", ["getTypes"]),
        ...mapActions("campingClubs", ["getCampingClubs"]),
        changeViewing(viewing) {
            this.viewing = viewing;
        },
        getInitReferences() {
            const {
                camping,
                dateFrom,
                dateTo,
                type,
                adult,
                child,
                child1,
                animal,
                categorie
            } = this.filter;

            if (!dateFrom || !dateTo) {
                this.$bvToast.toast("Please select date from, date to", {
                    title: `Error`,
                    variant: "danger",
                    solid: true
                });
                return;
            }
            let dataReferences = {
                camping: camping,
                dateFrom: dateFrom,
                dateTo: dateTo,
                type: type,
                adult: adult,
                child: child,
                child1: child1
            };
            if (categorie) {
                dataReferences.categorie = categorie;
            }
            if (animal) {
                dataReferences.animal = animal;
            }
            this.getReferences(dataReferences).then(res => {
                const { references } = res;
                if (references) {
                    const categoryIds = map(references, item => item.id);
                    const data = {
                        StartUtc: formatBookDate(dateFrom),
                        EndUtc: formatBookDate(dateTo),
                        AdultCount: adult,
                        ChildCount: Number(child) + Number(child1),
                        CategoryIds: categoryIds
                    };
                    this.getAvailability(data);
                }
            });
        },
        onGotoSearch() {
            const camping = first(this.campingClubs);
            let dataReferences = {
                camping: camping ? camping.id : null,
                dateFrom: formatBookDate(moment()),
                dateTo: formatBookDate(moment().add(2, "days")),
                type: null,
                adult: ADULT_COUNT_DEFAULT,
                child: 0,
                child1: 0
            };
            this.onGetRefences(dataReferences);
        },
        onGetRefences(dataReferences) {
            if (
                !dataReferences.dateFrom ||
                !dataReferences.dateTo ||
                dataReferences.adult <= 0
            ) {
                this.$bvToast.toast("Please select date from, date to", {
                    title: `Error`,
                    variant: "danger",
                    solid: true
                });
                return;
            }
            if (this.adult + this.child + this.child1 > 6) {
                this.$bvToast.toast(
                    this.$i18n.t(
                        "app.Les hébergements ne peuvent pas accueillir plus de 6 personnes"
                    ),
                    {
                        title: this.$i18n.t("app.Error"),
                        variant: "danger",
                        solid: true
                    }
                );
                return;
            }
            dataReferences = {
                ...dataReferences,
                dateFrom: formatBookDate(dataReferences.dateFrom),
                dateTo: formatBookDate(dataReferences.dateTo)
            };
            this.getReferences(dataReferences).then(res => {
                const { references } = res;
                if (references) {
                    const data = {
                        StartUtc: formatBookDate(dataReferences.dateFrom),
                        EndUtc: formatBookDate(dataReferences.dateTo),
                        AdultCount: dataReferences.adult,
                        ChildCount:
                            Number(dataReferences.child) +
                            Number(dataReferences.child1),
                        CategoryIds: map(references, item => item.id)
                    };
                    this.getAvailability(data);
                }
            });
        }
    }
};
</script>
